import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  NgZone,
} from "@angular/core";
// import * as moment from 'moment';
import { NavController } from "ionic-angular";
import { Observable, Subject } from "rxjs";
import { UserService } from "../../../../user/user.service";
import { NavigationService } from "../../../../services/navigation/navigation.service";
import { takeUntil, distinctUntilChanged } from "rxjs/operators";

/**
   * Logger Factory
   * @namespace title: is the titlte od previous page
   * <ute-toolbar [title]="prevPage"></ute-toolbar>
   * --- PUT INSIDE THE ionViewDidLoad ---
   * ionViewDidLoad() {
      if(this.navCtrl.getPrevious() !== null){
        this.prevPage = this.navCtrl.getPrevious().id;
      }
    }
*/

@Component({
  selector: "ute-toolbar",
  templateUrl: "ute-toolbar.component.html",
})
export class UteToolbarComponent implements OnChanges {
  public currentUser$: Observable<any>;
  @Input() title: any;
  @Input() pageName: any;
  @Input() icon: any;
  @Input() originPage: string;
  @Input() noButtons: boolean = false;

  @Output() onAction = new EventEmitter();

  public rootPage: any = "dashboard";
  public hasTitle: boolean;
  private user: any;
  public active: boolean;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public navCtrl: NavController,
    public userService: UserService,
    public nav: NavigationService,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.user = this.userService.currentUser$;
    let userSubj = this.userService.currentUser$;
    userSubj
      .pipe(takeUntil(this.unsubscribe), distinctUntilChanged())
      .subscribe((user) => {
        if (user) {
          this.active = user.active;
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onClickIcon(action) {
    this.onAction.emit(action);
  }

  ngOnChanges(change: SimpleChanges) {
    if (
      change.title &&
      this.navCtrl.getPrevious() &&
      this.navCtrl.getPrevious().id
    ) {
      if (change.title.currentValue === this.navCtrl.getActive().id) {
        this.title = "BACK";
      }
    }
    if (this.navCtrl.getPrevious() === null) {
      this.title = "BACK";
    }
    if (
      this.navCtrl.getPrevious() &&
      this.navCtrl.getPrevious().id === "login"
    ) {
      this.title = "dashboard";
    }
    if (change && change.pageName && change.pageName.currentValue.length > 0) {
      this.hasTitle = true;
    }
  }

  goToLogin() {
    this.zone.run(() => {
      this.navCtrl.push("login");
    });
  }

  goTologOut() {
    this.zone.run(() => {
      this.userService.logout().then((res) => {
        this.navCtrl.setRoot("dashboard").then((res) => {
          window.location.reload();
        });
        //this.navCtrl.push('dashboard');
        //
      });
    });
  }

  goToRegistration() {
    this.zone.run(() => {
      this.navCtrl.push("registration");
    });
  }

  goToPreviousPage() {
    this.zone.run(() => {
      if (this.pageName === "dashboard") return null;
      if (this.navCtrl.getPrevious() === null) {
        this.navCtrl.push("dashboard");
      } else {
        this.navCtrl.pop();
      }
    });
  }

  goToDashboard() {
    this.zone.run(() => {
      if (this.pageName === "dashboard") return null;
      this.navCtrl.push("dashboard");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-toolbar/ute-toolbar.component.ts